import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  private newsRef: firebase.firestore.CollectionReference;

  constructor() { 
    this.newsRef = firebase.firestore().collection(`${environment.firestorePath}/noticias`);
  }


  async getNews(){

    try {
      const querySnapshot = await this.newsRef.orderBy("datePost", "desc").get();

      if (querySnapshot.empty) {
        throw new Error(`El endpoint no tiene registros...`);
      }
      
      const news = querySnapshot.docs.map(doc => {
        const obj = doc.data();
        obj.id = doc.id;
        return obj;
      });

      return news; 
    } catch (error) {
      throw new Error(error);
    }

  }
}
